import { createContext } from "react";

const componentCategoryContext = createContext();

export default componentCategoryContext;
